import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';

const HouseJobMain = () => {
  return (
    <main>
      <Breadcrumb title="House Job / Internship Program" />

      <section className="py-12 px-4 md:px-20 bg-white text-gray-800">
        <div className="container mx-auto max-w-6xl">
            <br></br>
            <br></br>
          <h1 className="text-4xl font-bold text-blue-800 mb-6 mt-6 text-center">House Job / Internship Program</h1>
          <p className="text-center text-gray-500 text-sm italic mb-10">A Launchpad for Future Medical Professionals</p>

          {/* <img
            src="https://via.placeholder.com/900x400"
            className="w-full rounded-lg shadow-lg mb-10"
            alt="House Job Internship"
          /> */}

          <Section title="Importance of House Job in Medical Careers">
            House jobs allow recent graduates to apply theoretical knowledge in practical settings, enhancing their skills and building confidence in clinical environments.
          </Section>

          <Section title="Structure of Our Internship Program">
            <p>Our program spans 12 months and includes rotations through:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Internal Medicine</li>
              <li>Surgery</li>
              <li>Pediatrics</li>
              <li>Emergency Medicine</li>
              <li>Psychiatry</li>
            </ul>
          </Section>

          <Section title="Eligibility Criteria">
            MBBS degree holders eligible for provisional registration may apply. Strong academic records and a passion for healthcare excellence are preferred.
          </Section>

          <Section title="Benefits of Joining Our Program">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <ul className="list-disc pl-5 space-y-1">
                <li>Certificate of Completion</li>
                <li>Letter of Recommendation</li>
              </ul>
              <ul className="list-disc pl-5 space-y-1">
                <li>Stipend and Meals</li>
                <li>Career Counseling Sessions</li>
              </ul>
            </div>
          </Section>

          <Section title="Testimonials">
            <blockquote className="bg-gray-100 p-5 rounded-md shadow-inner italic">
              “The internship transformed me from a nervous graduate into a confident clinician.”
              <footer className="mt-2 text-sm font-medium text-right text-gray-500">— Dr. Ayesha, Class of 2023</footer>
            </blockquote>
          </Section>

          <Section title="Application Process">
            <p>Submit your credentials online via our portal:</p>
            <ol className="list-decimal pl-5 mt-2 space-y-1">
              <li>Online Form</li>
              <li>Upload Documents</li>
              <li>Interview</li>
              <li>Selection Notification</li>
            </ol>
          </Section>

          <Section title="Quick Info">
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Duration:</strong> 12 months</li>
              <li><strong>Stipend:</strong> Provided</li>
              <li><strong>Deadline:</strong> June 30, 2025</li>
            </ul>
          </Section>

          <Section title="Contact Us">
            <p>Email: <a href="mailto:internship@yourhospital.com" className="text-blue-600 underline">internship@yourhospital.com</a></p>
            <p>Phone: <a href="tel:+923001234567" className="text-blue-600 underline">+92-300-1234567</a></p>
          </Section>

          <div className="text-center mt-10">
            <a
              href="/apply"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-200"
            >
              Submit Application
            </a>
          </div>
        </div>
      </section>

    </main>
  );
};

// Reusable section wrapper
const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-700 mb-3">{title}</h2>
    <div className="text-gray-600">{children}</div>
  </div>
);

export default HouseJobMain;
